module.exports = __webpack_public_path__ + "img/account_300.f416c50c.jpg";